// Maserrichtung (Faserverlauf) eines Teils, persistiert in part.meta.grain.
// "length" = Maser längs (parallel zur Teil-Länge, der Normalfall),
// "width"  = Maser quer (parallel zur Teil-Breite),
// fehlend/"none" = egal, das Teil darf im Zuschnittplan frei gedreht werden.
// Engine-frei; nur gesetzte Werte landen im meta (Muster: visibility.js/miters.js).

const VALUES = [ "length", "width" ]

export function grainOf(part) {
  const value = part?.meta?.grain
  return VALUES.includes(value) ? value : null
}

// Neues meta mit gesetzter bzw. entfernter Maserrichtung
export function withGrain(part, value) {
  const meta = { ...part.meta }
  if (VALUES.includes(value)) meta.grain = value
  else delete meta.grain
  return meta
}

export function grainLabel(value) {
  if (value === "length") return "längs"
  if (value === "width") return "quer"
  return "egal"
}

// Kürzel für die Teile-Liste: Pfeil in Faserrichtung (Länge = waagerecht)
export function grainSymbol(value) {
  if (value === "length") return "↔"
  if (value === "width") return "↕"
  return ""
}
